/* import __COLOCATED_TEMPLATE__ from './content.hbs'; */
import type { IBvMenuItem } from 'volta/components/bv-menu';

import templateOnlyComponent from '@ember/component/template-only';

interface BvMenuItemContentSignature {
  Args: {
    item: IBvMenuItem;
  };
  Blocks: {
    default: [];
  };
}

const BvMenuItemContentComponent = templateOnlyComponent<BvMenuItemContentSignature>();

export default BvMenuItemContentComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'BvMenu::Item::Content': typeof BvMenuItemContentComponent;
    'bv-menu/item/content': typeof BvMenuItemContentComponent;
  }
}
